/*
  WrapsandTags — Hamper Preview Generator
  Inject this inside theme.liquid just before </body>
  Works with Smart Box Builder (SBB) plugin on Dawn theme.
*/

(function () {

  // ─── CONFIG ──────────────────────────────────────────────────────────────
  const PREVIEW_TITLE   = 'Your Hamper Preview';
  const CANVAS_SIZE     = 360;   // px — canvas is square
  const CELL_PADDING    = 10;    // px — gap between product cells
  const BORDER_RADIUS   = 14;    // px — rounded corners on cells
  const ACCENT_COLOR    = '#D4537E'; // match your brand (pink from WrapsandTags)
  const BG_COLOR        = '#FFF5F8'; // very light pink background
  // ─────────────────────────────────────────────────────────────────────────

  // Only run on the SBB review page
  function isReviewPage() {
    return !!document.querySelector('.boxListingMobile-module__box_listing_mobile__-k, [class*="boxListingMobile-module__box_listing_mobile"]');
  }

  // Collect all product image URLs from the SBB DOM
  function getProductImages() {
    const imgs = document.querySelectorAll('img[alt="img_product"]');
    return Array.from(imgs)
      .map(img => img.src)
      .filter(src => src && src.includes('cdn.shopify.com'));
  }

  // Draw the hamper preview onto a canvas element
  async function drawHamper(canvas, imageUrls) {
    const ctx   = canvas.getContext('2d');
    const W     = canvas.width;
    const H     = canvas.height;
    const n     = imageUrls.length;

    ctx.clearRect(0, 0, W, H);

    // Background
    ctx.fillStyle = BG_COLOR;
    roundRect(ctx, 0, 0, W, H, 16);
    ctx.fill();

    if (n === 0) {
      ctx.fillStyle = '#aaa';
      ctx.font = '14px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('No products found', W / 2, H / 2);
      return;
    }

    // Grid layout
    const cols    = n <= 1 ? 1 : n <= 4 ? 2 : 3;
    const rows    = Math.ceil(n / cols);
    const cellW   = (W - CELL_PADDING * (cols + 1)) / cols;
    const cellH   = (H - CELL_PADDING * (rows + 1)) / rows;

    // Load and draw each image
    const loadImg = (url) => new Promise(resolve => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      // Use Shopify's built-in image resizing — avoids CORS issues
      img.src = url.replace(/(\.[a-z]+)(\?|$)/, '_400x400$1$2');
      img.onload  = () => resolve(img);
      img.onerror = () => resolve(null); // gracefully skip broken images
    });

    const loaded = await Promise.all(imageUrls.map(loadImg));

    loaded.forEach((img, i) => {
      const col = i % cols;
      const row = Math.floor(i / cols);
      const x   = CELL_PADDING + col * (cellW + CELL_PADDING);
      const y   = CELL_PADDING + row * (cellH + CELL_PADDING);

      ctx.save();

      // Cell background
      ctx.fillStyle = '#fff';
      roundRect(ctx, x, y, cellW, cellH, BORDER_RADIUS);
      ctx.fill();

      if (img) {
        // Clip image to rounded cell
        roundRect(ctx, x, y, cellW, cellH, BORDER_RADIUS);
        ctx.clip();

        // Cover-fit the image inside the cell
        const scale = Math.max(cellW / img.width, cellH / img.height);
        const sw    = img.width  * scale;
        const sh    = img.height * scale;
        const sx    = x + (cellW - sw) / 2;
        const sy    = y + (cellH - sh) / 2;
        ctx.drawImage(img, sx, sy, sw, sh);
      } else {
        // Fallback placeholder
        ctx.fillStyle = '#f0f0f0';
        roundRect(ctx, x, y, cellW, cellH, BORDER_RADIUS);
        ctx.fill();
        ctx.fillStyle = '#ccc';
        ctx.font = '24px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText('🎁', x + cellW / 2, y + cellH / 2 + 8);
      }

      ctx.restore();
    });

    // Decorative border overlay
    ctx.save();
    ctx.strokeStyle = ACCENT_COLOR;
    ctx.lineWidth   = 2.5;
    ctx.globalAlpha = 0.5;
    roundRect(ctx, 4, 4, W - 8, H - 8, 16);
    ctx.stroke();
    ctx.restore();

    // "Custom Hamper" label badge at bottom
    const badgeW  = 140;
    const badgeH  = 26;
    const badgeX  = (W - badgeW) / 2;
    const badgeY  = H - badgeH - 10;
    ctx.save();
    ctx.fillStyle   = ACCENT_COLOR;
    ctx.globalAlpha = 0.92;
    roundRect(ctx, badgeX, badgeY, badgeW, badgeH, 8);
    ctx.fill();
    ctx.globalAlpha = 1;
    ctx.fillStyle   = '#fff';
    ctx.font        = '500 12px sans-serif';
    ctx.textAlign   = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Custom Hamper ✦', W / 2, badgeY + badgeH / 2);
    ctx.restore();
  }

  // Utility — CanvasRenderingContext2D rounded rect (compatible with older browsers)
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y,     x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h,     x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y,         x + r, y);
    ctx.closePath();
  }

  // Build and inject the preview UI above the Box Summary section
  function injectPreviewUI() {
    if (document.getElementById('wt-hamper-preview-wrap')) return; // already injected

    // Find the insertion point — just before the box listing container
    const container = document.querySelector(
      '[class*="boxListingMobile-module__box_listing_mobile"]'
    );
    if (!container) return;

    // Create wrapper
    const wrap = document.createElement('div');
    wrap.id = 'wt-hamper-preview-wrap';
    wrap.style.cssText = `
      margin: 0 16px 24px;
      background: ${BG_COLOR};
      border-radius: 16px;
      padding: 16px;
      border: 1px solid rgba(212, 83, 126, 0.2);
      font-family: inherit;
    `;

    // Title
    const title = document.createElement('p');
    title.textContent = PREVIEW_TITLE;
    title.style.cssText = `
      margin: 0 0 12px;
      font-size: 14px;
      font-weight: 600;
      color: #1a1a1a;
      letter-spacing: 0.01em;
    `;

    // Canvas
    const canvas = document.createElement('canvas');
    canvas.id     = 'wt-hamper-canvas';
    canvas.width  = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    canvas.style.cssText = `
      width: 100%;
      max-width: ${CANVAS_SIZE}px;
      height: auto;
      display: block;
      margin: 0 auto;
      border-radius: 16px;
    `;

    // Loading state
    const loader = document.createElement('p');
    loader.id = 'wt-hamper-loader';
    loader.textContent = 'Generating preview…';
    loader.style.cssText = `
      text-align: center;
      font-size: 13px;
      color: #888;
      margin: 8px 0 0;
    `;

    wrap.appendChild(title);
    wrap.appendChild(canvas);
    wrap.appendChild(loader);

    // Insert before the container
    container.parentNode.insertBefore(wrap, container);

    return canvas;
  }

  // Main — observe DOM for SBB to finish rendering, then inject
  function init() {
    if (!isReviewPage()) return;

    const canvas = injectPreviewUI();
    if (!canvas) return;

    const imageUrls = getProductImages();

    if (imageUrls.length > 0) {
      document.getElementById('wt-hamper-loader').textContent =
        `${imageUrls.length} item${imageUrls.length > 1 ? 's' : ''} in your hamper`;
      drawHamper(canvas, imageUrls);
    } else {
      // SBB loads asynchronously — watch for images to appear
      const observer = new MutationObserver(() => {
        const urls = getProductImages();
        if (urls.length > 0) {
          observer.disconnect();
          document.getElementById('wt-hamper-loader').textContent =
            `${urls.length} item${urls.length > 1 ? 's' : ''} in your hamper`;
          drawHamper(canvas, urls);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // SBB renders after page load — small delay ensures it's mounted
    setTimeout(init, 800);
  }

})();
